var _a;
import { Prior_Authorization_Status_Pa_Status } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[Prior_Authorization_Status_Pa_Status.Approved] = 'Approved',
    _a[Prior_Authorization_Status_Pa_Status.Denied] = 'Denied',
    _a[Prior_Authorization_Status_Pa_Status.InProgress] = 'In Progress',
    _a);
export var PriorAuthorizationStatusPaStatusEnum = {
    name: 'PriorAuthorizationStatusPaStatus',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
